import React, { Component } from 'react';
import ReportLayout from '../../../common/report/layout/report-layout.component';
import ReportDetails from '../../../common/report/details/report-details.component';
import { ReportBody } from '../../../common/report/details/report-details-body.component';

export class Order extends Component {
    constructor(props) {
        super(props);
        this.state={
            dataTable:[
                {
                    HeaderItem: [
                        {
                            name: "Contract Name"
                        },
                        {
                            name: "Vendor"
                        }, {
                            name: "Status"
                        }, {
                            name: "Service Type"
                        }, {
                            name: "Effective Date"
                        }, {
                            name: "Expiration Date"
                        }
                    ],
                    dataItem: [{
                        columnItem1: "3G Hutchison (GB) Contract",
                        columnItem2: "3G Hutchison (GB)",
                        columnItem3: "Expired",
                        columnItem5: "May 29, 2021",
                        columnItem6: "May 15, 2022",
                        columnItem7: "May 15, 2022",
                    }, {
                        columnItem1: "3G Hutchison (GB) Contract",
                        columnItem2: "3G Hutchison (GB)",
                        columnItem3: "Expired",
                        columnItem5: "May 29, 2021",
                        columnItem6: "May 15, 2022",
                        columnItem7: "May 15, 2022",
                    }, {
                        columnItem1: "3G Hutchison (GB) Contract",
                        columnItem2: "3G Hutchison (GB)",
                        columnItem3: "Expired",
                        columnItem5: "May 29, 2021",
                        columnItem6: "May 15, 2022",
                        columnItem7: "May 15, 2022",
                    }, {
                        columnItem1: "3G Hutchison (GB) Contract",
                        columnItem2: "3G Hutchison (GB)",
                        columnItem3: "Expired",
                        columnItem5: "May 29, 2021",
                        columnItem6: "May 15, 2022",
                        columnItem7: "May 15, 2022",
                    }
                    ]
    
                }
            ],
            pages : {
                HasNext: true,
                HasPrevious: false,
                PageNumber: 0,
                PerPage: 10,
                TotalEntries: 10,
                TotalPages: 10
    
            },
            barChart:[
                { name: "Jan 2021", Wireless:800, Wireline:80, HOC:50},
                { name: "Feb 2021", Wireless:798, Wireline:70, HOC:60},
                { name: "Mar 2021", Wireless:632, Wireline:60, HOC:10},
                { name: "Apr 2021", Wireless:875, Wireline:50, HOC:20},
                { name: "May 2021", Wireless:543, Wireline:20, HOC:15},
                { name: "June 2021", Wireless:768, Wireline:35, HOC:10}
          ],
          barData: [ 
            {name: 'HOC', color:'#d5002f'},
            {name: 'Wireline', color:'#ffc82c'},
            {name: 'Wireless', color:'#008eff'}          
          ],
          pieChart: [ 
            {name: 'Wireless', value:915, fill:"#008eff"},
            {name: 'Wireline', value:37, fill:"#ffc82c"},
            {name: 'HOC', value:9, fill:"#d5002f"}
          ],
          pieData: [ 
            {name: 'Wireless', color:'#008eff'}, 
            {name: 'Wireline', color:'#ffc82c'}, 
            {name: 'HOC', color:'#d5002f'}                     
    ],
    horizontalChart: [
        { name: "Verizon Wireless US", value:39975.2},
        { name: "Verizon Wireless US", value:104091.91}
  ],horizontalCharts : [
    { name: "United States of America", value:71957.54},
    { name: "United States of America", value:32174.37},
    { name: "Romania", value:34166.84},
    { name: "United States of America", value:0},
    { name: "United States of America", value:0}
],
region:[
    [         
        {name: 1000,  pv: 2400,  xVal:"Sample  1", linecolor:"#ff7f0e"},
        {name: 2000,  pv: 1398,  xVal:"Sample 2", },
        {name: 3000,  pv: 4800,  xVal:"Sample 3", },
        {name: 4000,  pv: 3908,  xVal:"Sample 4"},
        {name: 5000,  pv: 800,  xVal:"Sample 5"},
      ]
],
listTabInfo:{
    Tab:[
        {
            "id":"0",
            "label":"Phone"            
        },
        {
            "id":"1",
            "label":"Account"           
        }
    ]
},
secondData:[
    {
        HeaderItem:
            {
                title:"T-Mobile (US)",
                subTitle:"Vendor Volumetric"
            }
        ,
        items:[
            {
                total:"19",
                description:"Total Count of Active Account"
            },
            {
                total:"2k",
                description:"Total Count of Active Subscription"
            }
        ]
    },
    {
        HeaderItem:
        {
            title:"Verizon (US)",
            subTitle:"Vendor Volumetric"
        }
        ,
        items:[
            {
                total:"20",
                description:"Total Count of Active Account"
            },
            {
                total:"14",
                description:"Total Count of Active Subscription"
            },
            ,
            {
                total:"20K",
                description:"Total Count of Active Subscription"
            }
        ]
    }
]
        }       
    }
    render(){
        const {dataTable,pages,barChart,barData,pieChart,pieData,horizontalChart,horizontalCharts,region,secondData}=this.state
        return(
            <ReportLayout urlType="external">               
                  <ReportBody title="Order Report">
                     <ReportDetails columnTwoData={secondData} haveColumnTwo={false} haveTotalDetail={false} listTabInfo={this.state.listTabInfo} tabList={false} reportTitle="Order Volume Report Details" barChartTitle="Active Subscription Trends" pieChartTitle="Active Subscriptions per Service Tyoe" horizontalTitle="Vectors" horizontalTitles="Countires" costLineTitle="Cost Center" dataTable={dataTable} region={region} pages={pages} barChart={barChart} barData={barData} pieChart={pieChart} pieData={pieData} horizontalChart={horizontalChart} horizontalCharts={horizontalCharts}/> 
                     <ReportDetails columnTwoData={secondData} haveColumnTwo={false} haveTotalDetail={false} listTabInfo={this.state.listTabInfo} tabList={false} reportTitle="Order Pass Due Report Details" barChartTitle="Active Subscription Trends" pieChartTitle="Active Subscriptions per Service Tyoe" horizontalTitle="Vectors" horizontalTitles="Countires" costLineTitle="Cost Center" dataTable={dataTable} region={region} pages={pages} barChart={barChart} barData={barData} pieChart={pieChart} pieData={pieData} horizontalChart={horizontalChart} horizontalCharts={horizontalCharts}/>               
                     <ReportDetails columnTwoData={secondData} haveColumnTwo={false} haveTotalDetail={false} listTabInfo={this.state.listTabInfo} tabList={false} reportTitle="Completed Order Not Yet Billing Report Details" barChartTitle="Active Subscription Trends" pieChartTitle="Active Subscriptions per Service Tyoe" horizontalTitle="Vectors" horizontalTitles="Countires" costLineTitle="Cost Center" dataTable={dataTable} region={region} pages={pages} barChart={barChart} barData={barData} pieChart={pieChart} pieData={pieData} horizontalChart={horizontalChart} horizontalCharts={horizontalCharts}/>               
                 
                  </ReportBody>
            </ReportLayout>
        )
    }
}